import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { LandingHeader } from "@/components/landing/LandingHeader";
import { HeroSection } from "@/components/landing/HeroSection";

import { TradingCenterFeatures } from "@/components/landing/TradingCenterFeatures";
import { TrustBar } from "@/components/landing/TrustBar";
import { PartnerSection } from "@/components/landing/PartnerSection";
import { InsightsSection } from "@/components/landing/InsightsSection";
import { AboutSection } from "@/components/landing/AboutSection";
import { CommunitySection } from "@/components/landing/CommunitySection";
import { LandingFooter } from "@/components/landing/LandingFooter";
import { LoginModal } from "@/components/landing/LoginModal";
import { PartnerLoginModal } from "@/components/landing/PartnerLoginModal";

export const Landing = () => {
  const [loginOpen, setLoginOpen] = useState(false);
  const [partnerOpen, setPartnerOpen] = useState(false);
  const location = useLocation();

  // Scroll to hash on mount / hash change (e.g. arriving from /pricing nav)
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      // Defer to allow page to paint
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 50);
    }
  }, [location.hash]);

  const handleEnter = () => setLoginOpen(true);
  const handleLogin = () => setLoginOpen(true);
  const handleCommunity = () => setLoginOpen(true);
  const handlePartner = () => setPartnerOpen(true);

  return (
    <div className="min-h-screen bg-background relative overflow-x-hidden">
      {/* Page-wide soft gradient background */}
      <div className="pointer-events-none fixed inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-[hsl(220,25%,97%)] via-background to-background" />
        <div className="absolute top-1/3 -left-32 h-[600px] w-[600px] rounded-full bg-emerald-300/10 blur-[140px]" />
        <div className="absolute top-2/3 -right-32 h-[600px] w-[600px] rounded-full bg-primary/10 blur-[140px]" />
      </div>

      <LandingHeader onLogin={handleLogin} onCTA={handleEnter} onPartner={handlePartner} />
      <main>
        <HeroSection onCTA={handleEnter} />
        <TradingCenterFeatures />
        <TrustBar />
        <CommunitySection onCommunityCTA={handleCommunity} />
        <PartnerSection onPartnerCTA={handlePartner} />
        <InsightsSection />
        <AboutSection />
      </main>
      <LandingFooter />

      <LoginModal open={loginOpen} onOpenChange={setLoginOpen} />
      <PartnerLoginModal open={partnerOpen} onOpenChange={setPartnerOpen} />
    </div>
  );
};

export default Landing;
